/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LinkPipedriveDealInput = {
    projectId?: string | null | undefined;
    dealId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type LinkPipedriveDealMutationVariables = {
    input: LinkPipedriveDealInput;
};
export type LinkPipedriveDealMutationResponse = {
    readonly linkPipedriveDeal: {
        readonly project: {
            readonly pipedriveDeal: string | null;
        } | null;
    } | null;
};
export type LinkPipedriveDealMutation = {
    readonly response: LinkPipedriveDealMutationResponse;
    readonly variables: LinkPipedriveDealMutationVariables;
};



/*
mutation LinkPipedriveDealMutation(
  $input: LinkPipedriveDealInput!
) {
  linkPipedriveDeal(input: $input) {
    project {
      pipedriveDeal
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "LinkPipedriveDealInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "linkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "linkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "LinkPipedriveDealMutation",
    "operationKind": "mutation",
    "text": "mutation LinkPipedriveDealMutation(\n  $input: LinkPipedriveDealInput!\n) {\n  linkPipedriveDeal(input: $input) {\n    project {\n      pipedriveDeal\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c1606868eae977de36c41cbee466438c';
export default node;
